import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';

const modeInfo = {
  add: {
    title: '個別風機點位工進新增',
  },
  edit: {
    title: '個別風機點位工進編輯',
  },
  view: {
    title: '個別風機點位工進檢視',
  },
  '': {
    title: '',
  },
};

class FanDetail extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, getPPFanIdDetail, mode = '', setPageText, getBaseData } = this.props;
    getBaseData();
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getPPFanIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { PPFanIdDetail: prePPFanIdDetail = {} } = preProps;
    const { PPFanIdDetail = {}, mode } = this.props;
    if (Object.keys(prePPFanIdDetail).length === 0 && Object.keys(PPFanIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: PPFanIdDetail, old_data: PPFanIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('PPFanIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      fan_point: data.fan_point,
      underwater_base_type: data.underwater_base_type,
      wathch_depth: data.wathch_depth || '',
      foundation_made_stage: data.foundation_made_stage,
      foundation_plan_made_date: data.foundation_plan_made_date,
      foundation_actual_made_date: data.foundation_actual_made_date,
      foundation_tran_taiwan: data.foundation_tran_taiwan,
      foundation_is_tran_taiwan: data.foundation_is_tran_taiwan,
      foundation_tw_date: data.foundation_tw_date,
      foundation_actual_tw_date: data.foundation_actual_tw_date,
      foundation_progress: data.foundation_progress,
      foundation_plan_install_date: data.foundation_plan_install_date,
      foundation_actual_install_date: data.foundation_actual_install_date,
      tp_made_stage: data.tp_made_stage,
      tp_plan_made_date: data.tp_plan_made_date,
      tp_actual_made_date: data.tp_actual_made_date,
      tp_tran_taiwan: data.tp_tran_taiwan,
      tp_is_tran_taiwan: data.tp_is_tran_taiwan,
      tp_tw_date: data.tp_tw_date,
      tp_actual_tw_date: data.tp_actual_tw_date,
      tp_progress: data.tp_progress,
      tp_plan_install_start_date: data.tp_plan_install_start_date,
      tp_plan_install_end_date: data.tp_plan_install_end_date,
      tp_actual_install_date: data.tp_actual_install_date,
      cabin_made_stage: data.cabin_made_stage,
      cabin_plan_made_date: data.cabin_plan_made_date,
      cabin_actual_made_date: data.cabin_actual_made_date,
      cabin_tran_taiwan: data.cabin_tran_taiwan,
      cabin_is_tran_taiwan: data.cabin_is_tran_taiwan,
      cabin_tw_date: data.cabin_tw_date,
      cabin_actual_tw_date: data.cabin_actual_tw_date,
      tower_made_stage: data.tower_made_stage,
      tower_plan_made_date: data.tower_plan_made_date,
      tower_actual_made_date: data.tower_actual_made_date,
      tower_tran_taiwan: data.tower_tran_taiwan,
      tower_is_tran_taiwan: data.tower_is_tran_taiwan,
      tower_tw_date: data.tower_tw_date,
      tower_actual_tw_date: data.tower_actual_tw_date,
      blade_made_stage: data.blade_made_stage,
      blade_plan_made_date: data.blade_plan_made_date,
      blade_actual_made_date: data.blade_actual_made_date,
      blade_tran_taiwan: data.blade_tran_taiwan,
      blade_is_tran_taiwan: data.blade_is_tran_taiwan,
      blade_tw_date: data.blade_tw_date,
      blade_actual_tw_date: data.blade_actual_tw_date,
      install_stage: data.install_stage,
      install_plan_date: data.install_plan_date,
      install_actual_date: data.install_actual_date,
      merge_plan_date: data.merge_plan_date,
      merge_actual_date: data.merge_actual_date,

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewPPFan } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewPPFan(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { id, putPPFanIdDetail } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putPPFanIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.fan_point) === '', // 0 風機編號
      returnInputValue(data.underwater_base_type) === '', // 1 水下基礎型式
      false, // 2 水深
      returnInputValue(data.foundation_made_stage) === '', // 3 基樁 製造 進度
      returnInputValue(data.foundation_plan_made_date) === '', // 4 基樁 製造 預定日期
      data.foundation_made_stage === '3' && returnInputValue(data.foundation_actual_made_date) === '', // 5 基樁 製造 實際日期
      returnInputValue(data.foundation_tran_taiwan) === '', // 6 基樁 運輸 需要來台
      data.foundation_tran_taiwan === '1' && returnInputValue(data.foundation_is_tran_taiwan) === '', // 7 基樁 運輸 是否抵台
      data.foundation_tran_taiwan === '1' && returnInputValue(data.foundation_tw_date) === '', // 8 基樁 運輸 預定日期
      data.foundation_tran_taiwan === '1' && data.foundation_is_tran_taiwan === '1' && returnInputValue(data.foundation_actual_tw_date) === '', // 9 基樁 運輸 實際日期
      returnInputValue(data.foundation_progress) === '', // 10 基樁 安裝 進度
      returnInputValue(data.foundation_plan_install_date) === '', // 11 基樁 安裝 預定日期
      data.foundation_progress === '3' && returnInputValue(data.foundation_actual_install_date) === '', // 12 基樁 安裝 實際日期
      returnInputValue(data.tp_made_stage) === '', // 13 套筒 製造 進度
      returnInputValue(data.tp_plan_made_date) === '', // 14 套筒 製造 預定日期
      data.tp_made_stage === '3' && returnInputValue(data.tp_actual_made_date) === '', // 15 套筒 製造 實際日期
      returnInputValue(data.tp_tran_taiwan) === '', // 16 套筒 運輸 需要來台
      data.tp_tran_taiwan === '1' && returnInputValue(data.tp_is_tran_taiwan) === '', // 17 套筒 運輸 是否抵台
      data.tp_tran_taiwan === '1' && returnInputValue(data.tp_tw_date) === '', // 18 套筒 運輸 預定日期
      data.tp_tran_taiwan === '1' && data.tp_is_tran_taiwan === '1' && returnInputValue(data.tp_actual_tw_date) === '', // 19 套筒 運輸 實際日期
      returnInputValue(data.tp_progress) === '', // 20 套筒 安裝 進度
      returnInputValue(data.tp_plan_install_start_date) === '', // 21 套筒 安裝 預定開始日期
      returnInputValue(data.tp_plan_install_end_date) === '', // 22 套筒 安裝 預定結束日期
      data.tp_progress === '3' && returnInputValue(data.tp_actual_install_date) === '', // 23 套筒 安裝 實際日期
      returnInputValue(data.cabin_made_stage) === '', // 24 機艙/塔架/葉片 機艙 進度
      returnInputValue(data.cabin_plan_made_date) === '', // 25 機艙/塔架/葉片 機艙 預定製造日期
      data.cabin_made_stage === '3' && returnInputValue(data.cabin_actual_made_date) === '', // 26 機艙/塔架/葉片 機艙 實際製造日期
      returnInputValue(data.cabin_tran_taiwan) === '', // 27 機艙/塔架/葉片 機艙 需要來台
      data.cabin_tran_taiwan === '1' && returnInputValue(data.cabin_is_tran_taiwan) === '', // 28 機艙/塔架/葉片 機艙 是否抵台
      data.cabin_tran_taiwan === '1' && returnInputValue(data.cabin_tw_date) === '', // 29 機艙/塔架/葉片 機艙 預定抵台日期
      data.cabin_tran_taiwan === '1' && data.cabin_is_tran_taiwan === '1' && returnInputValue(data.cabin_actual_tw_date) === '', // 30 機艙/塔架/葉片 機艙 實際抵台日期
      returnInputValue(data.tower_made_stage) === '', // 31 機艙/塔架/葉片 塔架 進度
      returnInputValue(data.tower_plan_made_date) === '', // 32 機艙/塔架/葉片 塔架 預定製造日期
      data.tower_made_stage === '3' && returnInputValue(data.tower_actual_made_date) === '', // 33 機艙/塔架/葉片 塔架 實際製造日期
      returnInputValue(data.tower_tran_taiwan) === '', // 34 機艙/塔架/葉片 塔架 需要來台
      data.tower_tran_taiwan === '1' && returnInputValue(data.tower_is_tran_taiwan) === '', // 35 機艙/塔架/葉片 塔架 是否抵台
      data.tower_tran_taiwan === '1' && returnInputValue(data.tower_tw_date) === '', // 36 機艙/塔架/葉片 塔架 預定抵台日期
      data.tower_tran_taiwan === '1' && data.tower_is_tran_taiwan === '1' && returnInputValue(data.tower_actual_tw_date) === '', // 37 機艙/塔架/葉片 塔架 實際抵台日期
      returnInputValue(data.blade_made_stage) === '', // 38 機艙/塔架/葉片 葉片 進度
      returnInputValue(data.blade_plan_made_date) === '', // 39 機艙/塔架/葉片 葉片 預定製造日期
      data.blade_made_stage === '3' && returnInputValue(data.blade_actual_made_date) === '', // 40 機艙/塔架/葉片 葉片 實際製造日期
      returnInputValue(data.blade_tran_taiwan) === '', // 41 機艙/塔架/葉片 葉片 需要來台
      data.blade_tran_taiwan === '1' && returnInputValue(data.blade_is_tran_taiwan) === '', // 42 機艙/塔架/葉片 葉片 是否抵台
      data.blade_tran_taiwan === '1' && returnInputValue(data.blade_tw_date) === '', // 43 機艙/塔架/葉片 葉片 預定抵台日期
      data.blade_tran_taiwan === '1' && data.blade_is_tran_taiwan === '1' && returnInputValue(data.blade_actual_tw_date) === '', // 44 機艙/塔架/葉片 葉片 實際抵台日期
      returnInputValue(data.install_stage) === '', // 45 安裝 進度
      returnInputValue(data.install_plan_date) === '', // 46 安裝 預定安裝日期
      data.install_stage === '3' && returnInputValue(data.install_actual_date) === '', // 47 安裝 實際安裝日期
      returnInputValue(data.merge_plan_date) === '', // 48 安裝 預定併聯日期
      data.install_stage === '4' && returnInputValue(data.merge_actual_date) === '', // 49 安裝 實際併聯日期
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { mode = '', AProUnderWaterList = [], PPFanIdList = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck || (!getStatus.canEdit(data));
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };
    const allRight = errorAry.indexOf(true) === -1;

    const titleWidth = 155;
    const errorLeft = 20 + titleWidth;

    return (
      <div
        style={{
          position: 'absolute',
          left: 13,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          overflow: 'auto',
          backgroundColor: 'white',
        }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='風機編號' bol={true} haveChange={checkChange('fan_point')} />
              <EAA_Select displayBorder disabled={disabled} list={PPFanIdList.map(o => ({ name: o, value: o }))} value={returnInputValue(data.fan_point)} onChange={data => this.changeData({ label: 'fan_point', data })} />
            </EAA_ItemContainer>
            <EAA_ErrorText marginLeft={errorLeft} text='註:施工許可提供之點位編號選單，如需更改請來信說明' />
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='水下基礎型式' bol={true} haveChange={checkChange('underwater_base_type')} />
              <EAA_Select displayBorder disabled={disabled} list={AProUnderWaterList} value={returnInputValue(data.underwater_base_type)} onChange={data => this.changeData({ label: 'underwater_base_type', data })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='水深' haveChange={checkChange('wathch_depth')} />
              <EAA_Input displayBorder disabled={disabled} type='number' unit='公尺' value={returnInputValue(data.wathch_depth)} onChange={data => this.changeData({ label: 'wathch_depth', data })} />
            </EAA_ItemContainer>
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <SearchBar style={{ marginTop: 8 }} text='基樁' forceOpen={returnForceOpen({ least: 3, most: 12 })}>
          <SearchBar style={{ marginTop: 8 }} text='基樁製造' defaultOpen forceOpen={returnForceOpen({ least: 3, most: 5 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='基樁製造進度' bol={true} haveChange={checkChange('foundation_made_stage')} />
                  <CircleCheckBox disabled={disabled} value={data.foundation_made_stage === '1'} onClick={() => this.changeData({ label: 'foundation_made_stage', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.foundation_made_stage === '2'} onClick={() => this.changeData({ label: 'foundation_made_stage', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                  <CircleCheckBox disabled={disabled} value={data.foundation_made_stage === '3'} onClick={() => this.changeData({ label: 'foundation_made_stage', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol haveChange={checkChange('foundation_plan_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_plan_made_date)} onChange={data => this.changeData({ label: 'foundation_plan_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={data.foundation_made_stage === '3'} haveChange={checkChange('foundation_actual_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_actual_made_date)} onChange={data => this.changeData({ label: 'foundation_actual_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>
          </SearchBar>

          <SearchBar style={{ marginTop: 8 }} text='基樁運輸' defaultOpen forceOpen={returnForceOpen({ least: 6, most: 9 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='基樁需運輸來台' bol={true} haveChange={checkChange('foundation_tran_taiwan')} />
                  <CircleCheckBox disabled={disabled} value={data.foundation_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'foundation_tran_taiwan', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.foundation_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'foundation_tran_taiwan', data: '2' })} />
                  <div style={{ marginLeft: 4 }}>否</div>
                </EAA_ItemContainer>
                {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            {data.foundation_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('foundation_is_tran_taiwan')} />
                    <CircleCheckBox disabled={disabled} value={data.foundation_is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'foundation_is_tran_taiwan', data: '1' })} />
                    <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                    <CircleCheckBox disabled={disabled} value={data.foundation_is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'foundation_is_tran_taiwan', data: '2' })} />
                    <div style={{ marginLeft: 4 }}>否</div>
                  </EAA_ItemContainer>
                  {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
              </EAA_Row>
            )}

            {data.foundation_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='基樁預定抵台日期' bol={true} haveChange={checkChange('foundation_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_tw_date)} onChange={data => this.changeData({ label: 'foundation_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={data.foundation_is_tran_taiwan === '1'} haveChange={checkChange('foundation_actual_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_actual_tw_date)} onChange={data => this.changeData({ label: 'foundation_actual_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
              </EAA_Row>
            )}
          </SearchBar>

          <SearchBar style={{ marginTop: 8 }} text='基樁安裝' defaultOpen forceOpen={returnForceOpen({ least: 10, most: 12 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='基樁安裝進度' bol={true} haveChange={checkChange('foundation_progress')} />
                  <CircleCheckBox disabled={disabled} value={data.foundation_progress === '1'} onClick={() => this.changeData({ label: 'foundation_progress', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.foundation_progress === '2'} onClick={() => this.changeData({ label: 'foundation_progress', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>施工中</div>
                  <CircleCheckBox disabled={disabled} value={data.foundation_progress === '3'} onClick={() => this.changeData({ label: 'foundation_progress', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定安裝完成日期' bol={true} haveChange={checkChange('foundation_plan_install_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_plan_install_date)} onChange={data => this.changeData({ label: 'foundation_plan_install_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際安裝完成日期' bol={data.foundation_progress === '3'} haveChange={checkChange('foundation_actual_install_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.foundation_actual_install_date)} onChange={data => this.changeData({ label: 'foundation_actual_install_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[12] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>
          </SearchBar>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='套筒/TP' forceOpen={returnForceOpen({ least: 13, most: 23 })}>
          <SearchBar style={{ marginTop: 8 }} text='套筒/TP製造' defaultOpen forceOpen={returnForceOpen({ least: 13, most: 15 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='套筒/TP製造進度' bol={true} haveChange={checkChange('tp_made_stage')} />
                  <CircleCheckBox disabled={disabled} value={data.tp_made_stage === '1'} onClick={() => this.changeData({ label: 'tp_made_stage', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.tp_made_stage === '2'} onClick={() => this.changeData({ label: 'tp_made_stage', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                  <CircleCheckBox disabled={disabled} value={data.tp_made_stage === '3'} onClick={() => this.changeData({ label: 'tp_made_stage', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[13] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol={true} haveChange={checkChange('tp_plan_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_plan_made_date)} onChange={data => this.changeData({ label: 'tp_plan_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[14] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={data.tp_made_stage === '3'} haveChange={checkChange('tp_actual_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_actual_made_date)} onChange={data => this.changeData({ label: 'tp_actual_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[15] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>
          </SearchBar>
          <SearchBar style={{ marginTop: 8 }} text='套筒/TP運輸' defaultOpen forceOpen={returnForceOpen({ least: 16, most: 19 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='套筒/TP需運輸來台' bol={true} haveChange={checkChange('tp_tran_taiwan')} />
                  <CircleCheckBox disabled={disabled} value={data.tp_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'tp_tran_taiwan', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.tp_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'tp_tran_taiwan', data: '2' })} />
                  <div style={{ marginLeft: 4 }}>否</div>
                </EAA_ItemContainer>
                {errorAry[16] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            {data.tp_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('tp_is_tran_taiwan')} />
                    <CircleCheckBox disabled={disabled} value={data.tp_is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'tp_is_tran_taiwan', data: '1' })} />
                    <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                    <CircleCheckBox disabled={disabled} value={data.tp_is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'tp_is_tran_taiwan', data: '2' })} />
                    <div style={{ marginLeft: 4 }}>否</div>
                  </EAA_ItemContainer>
                  {errorAry[17] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
              </EAA_Row>
            )}

            {data.tp_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='套筒預定抵台日期' bol={true} haveChange={checkChange('tp_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_tw_date)} onChange={data => this.changeData({ label: 'tp_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[18] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={data.tp_is_tran_taiwan === '1'} haveChange={checkChange('tp_actual_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_actual_tw_date)} onChange={data => this.changeData({ label: 'tp_actual_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[19] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
              </EAA_Row>
            )}
          </SearchBar>

          <SearchBar style={{ marginTop: 8 }} text='套筒/TP安裝' defaultOpen forceOpen={returnForceOpen({ least: 20, most: 23 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='套筒/TP安裝進度' bol={true} haveChange={checkChange('tp_progress')} />
                  <CircleCheckBox disabled={disabled} value={data.tp_progress === '1'} onClick={() => this.changeData({ label: 'tp_progress', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.tp_progress === '2'} onClick={() => this.changeData({ label: 'tp_progress', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>施工中</div>
                  <CircleCheckBox disabled={disabled} value={data.tp_progress === '3'} onClick={() => this.changeData({ label: 'tp_progress', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[20] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定安裝開始日期' bol={true} haveChange={checkChange('tp_plan_install_start_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_plan_install_start_date)} onChange={data => this.changeData({ label: 'tp_plan_install_start_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[21] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定安裝完成日期' bol={true} haveChange={checkChange('tp_plan_install_end_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_plan_install_end_date)} onChange={data => this.changeData({ label: 'tp_plan_install_end_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[22] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際安裝完成日期' bol={data.tp_progress === '3'} haveChange={checkChange('tp_actual_install_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tp_actual_install_date)} onChange={data => this.changeData({ label: 'tp_actual_install_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[23] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item />
            </EAA_Row>
          </SearchBar>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='機艙/塔架/葉片' forceOpen={returnForceOpen({ least: 24, most: 44 })}>
          <SearchBar style={{ marginTop: 8 }} defaultOpen text='機艙製造/運輸' forceOpen={returnForceOpen({ least: 24, most: 30 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='機艙製造進度' bol={true} haveChange={checkChange('cabin_made_stage')} />
                  <CircleCheckBox disabled={disabled} value={data.cabin_made_stage === '1'} onClick={() => this.changeData({ label: 'cabin_made_stage', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.cabin_made_stage === '2'} onClick={() => this.changeData({ label: 'cabin_made_stage', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                  <CircleCheckBox disabled={disabled} value={data.cabin_made_stage === '3'} onClick={() => this.changeData({ label: 'cabin_made_stage', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[24] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol={true} haveChange={checkChange('cabin_plan_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.cabin_plan_made_date)} onChange={data => this.changeData({ label: 'cabin_plan_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[25] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={data.cabin_made_stage === '3'} haveChange={checkChange('cabin_actual_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.cabin_actual_made_date)} onChange={data => this.changeData({ label: 'cabin_actual_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[26] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='機艙需運輸來台' bol={true} haveChange={checkChange('cabin_tran_taiwan')} />
                  <CircleCheckBox disabled={disabled} value={data.cabin_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'cabin_tran_taiwan', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.cabin_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'cabin_tran_taiwan', data: '2' })} />
                  <div style={{ marginLeft: 4 }}>否</div>
                </EAA_ItemContainer>
                {errorAry[27] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            {data.cabin_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('cabin_is_tran_taiwan')} />
                    <CircleCheckBox disabled={disabled} value={data.cabin_is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'cabin_is_tran_taiwan', data: '1' })} />
                    <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                    <CircleCheckBox disabled={disabled} value={data.cabin_is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'cabin_is_tran_taiwan', data: '2' })} />
                    <div style={{ marginLeft: 4 }}>否</div>
                  </EAA_ItemContainer>
                  {errorAry[28] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
              </EAA_Row>
            )}

            {data.cabin_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='機艙預定抵台日期' bol={true} haveChange={checkChange('cabin_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.cabin_tw_date)} onChange={data => this.changeData({ label: 'cabin_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[29] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={data.cabin_is_tran_taiwan === '1'} haveChange={checkChange('cabin_actual_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.cabin_actual_tw_date)} onChange={data => this.changeData({ label: 'cabin_actual_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[30] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
              </EAA_Row>
            )}
          </SearchBar>

          <SearchBar style={{ marginTop: 8 }} defaultOpen text='塔架製造/運輸' forceOpen={returnForceOpen({ least: 31, most: 37 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='塔架製造進度' bol={true} haveChange={checkChange('tower_made_stage')} />
                  <CircleCheckBox disabled={disabled} value={data.tower_made_stage === '1'} onClick={() => this.changeData({ label: 'tower_made_stage', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.tower_made_stage === '2'} onClick={() => this.changeData({ label: 'tower_made_stage', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                  <CircleCheckBox disabled={disabled} value={data.tower_made_stage === '3'} onClick={() => this.changeData({ label: 'tower_made_stage', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[31] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol={true} haveChange={checkChange('tower_plan_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tower_plan_made_date)} onChange={data => this.changeData({ label: 'tower_plan_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[32] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={data.tower_made_stage === '3'} haveChange={checkChange('tower_actual_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tower_actual_made_date)} onChange={data => this.changeData({ label: 'tower_actual_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[33] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='塔架需運輸來台' bol={true} haveChange={checkChange('tower_tran_taiwan')} />
                  <CircleCheckBox disabled={disabled} value={data.tower_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'tower_tran_taiwan', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.tower_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'tower_tran_taiwan', data: '2' })} />
                  <div style={{ marginLeft: 4 }}>否</div>
                </EAA_ItemContainer>
                {errorAry[34] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            {data.tower_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('tower_is_tran_taiwan')} />
                    <CircleCheckBox disabled={disabled} value={data.tower_is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'tower_is_tran_taiwan', data: '1' })} />
                    <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                    <CircleCheckBox disabled={disabled} value={data.tower_is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'tower_is_tran_taiwan', data: '2' })} />
                    <div style={{ marginLeft: 4 }}>否</div>
                  </EAA_ItemContainer>
                  {errorAry[35] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
              </EAA_Row>
            )}

            {data.tower_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='塔架預定抵台日期' bol={true} haveChange={checkChange('tower_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tower_tw_date)} onChange={data => this.changeData({ label: 'tower_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[36] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={data.tower_is_tran_taiwan === '1'} haveChange={checkChange('tower_actual_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.tower_actual_tw_date)} onChange={data => this.changeData({ label: 'tower_actual_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[37] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
              </EAA_Row>
            )}

          </SearchBar>
          <SearchBar style={{ marginTop: 8 }} defaultOpen text='葉片製造/運輸' forceOpen={returnForceOpen({ least: 38, most: 44 })} openBackgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='葉片製造進度' bol={true} haveChange={checkChange('blade_made_stage')} />
                  <CircleCheckBox disabled={disabled} value={data.blade_made_stage === '1'} onClick={() => this.changeData({ label: 'blade_made_stage', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                  <CircleCheckBox disabled={disabled} value={data.blade_made_stage === '2'} onClick={() => this.changeData({ label: 'blade_made_stage', data: '2' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>製造中</div>
                  <CircleCheckBox disabled={disabled} value={data.blade_made_stage === '3'} onClick={() => this.changeData({ label: 'blade_made_stage', data: '3' })} />
                  <div style={{ marginLeft: 4 }}>已完成</div>
                </EAA_ItemContainer>
                {errorAry[38] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='預定製造完成日期' bol={true} haveChange={checkChange('blade_plan_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.blade_plan_made_date)} onChange={data => this.changeData({ label: 'blade_plan_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[39] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='實際製造完成日期' bol={data.blade_made_stage === '3'} haveChange={checkChange('blade_actual_made_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.blade_actual_made_date)} onChange={data => this.changeData({ label: 'blade_actual_made_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[40] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='葉片需運輸來台' bol={true} haveChange={checkChange('blade_tran_taiwan')} />
                  <CircleCheckBox disabled={disabled} value={data.blade_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'blade_tran_taiwan', data: '1' })} />
                  <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                  <CircleCheckBox disabled={disabled} value={data.blade_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'blade_tran_taiwan', data: '2' })} />
                  <div style={{ marginLeft: 4 }}>否</div>
                </EAA_ItemContainer>
                {errorAry[41] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
              </EAA_Item>
            </EAA_Row>

            {data.blade_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='是否已運抵台' bol={true} haveChange={checkChange('blade_is_tran_taiwan')} />
                    <CircleCheckBox disabled={disabled} value={data.blade_is_tran_taiwan === '1'} onClick={() => this.changeData({ label: 'blade_is_tran_taiwan', data: '1' })} />
                    <div style={{ marginLeft: 4, marginRight: 8 }}>是</div>
                    <CircleCheckBox disabled={disabled} value={data.blade_is_tran_taiwan === '2'} onClick={() => this.changeData({ label: 'blade_is_tran_taiwan', data: '2' })} />
                    <div style={{ marginLeft: 4 }}>否</div>
                  </EAA_ItemContainer>
                  {errorAry[42] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
              </EAA_Row>
            )}

            {data.blade_tran_taiwan === '1' && (
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='葉片預定抵台日期' bol={true} haveChange={checkChange('blade_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.blade_tw_date)} onChange={data => this.changeData({ label: 'blade_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[43] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='實際抵台日期' bol={data.blade_is_tran_taiwan === '1'} haveChange={checkChange('blade_actual_tw_date')} />
                    <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.blade_actual_tw_date)} onChange={data => this.changeData({ label: 'blade_actual_tw_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[44] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
              </EAA_Row>
            )}
          </SearchBar>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='安裝' forceOpen={returnForceOpen({ least: 45, most: 49 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='風機施工進度' bol={true} haveChange={checkChange('install_stage')} />
                <CircleCheckBox disabled={disabled} value={data.install_stage === '1'} onClick={() => this.changeData({ label: 'install_stage', data: '1' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>未開始</div>
                <CircleCheckBox disabled={disabled} value={data.install_stage === '2'} onClick={() => this.changeData({ label: 'install_stage', data: '2' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>安裝中</div>
                <CircleCheckBox disabled={disabled} value={data.install_stage === '3'} onClick={() => this.changeData({ label: 'install_stage', data: '3' })} />
                <div style={{ marginLeft: 4, marginRight: 8 }}>安裝完成</div>
                <CircleCheckBox disabled={disabled} value={data.install_stage === '4'} onClick={() => this.changeData({ label: 'install_stage', data: '4' })} />
                <div style={{ marginLeft: 4 }}>併聯完成</div>
              </EAA_ItemContainer>
              {errorAry[45] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定安裝完成日期' bol={true} haveChange={checkChange('install_plan_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.install_plan_date)} onChange={data => this.changeData({ label: 'install_plan_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[46] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際安裝完成日期' bol={data.install_stage === '3'} haveChange={checkChange('install_actual_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.install_actual_date)} onChange={data => this.changeData({ label: 'install_actual_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[47] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='預定併聯日期' bol={true} haveChange={checkChange('merge_plan_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.merge_plan_date)} onChange={data => this.changeData({ label: 'merge_plan_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[48] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='實際併聯日期' bol={data.install_stage === '4'} haveChange={checkChange('merge_actual_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.merge_actual_date)} onChange={data => this.changeData({ label: 'merge_actual_date', data: getTime.getType3Time(data) })} />
              </EAA_ItemContainer>
              {errorAry[49] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
          </EAA_Row>
        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          {...{
            data,
            mode,
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewPPFan' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutPPFanIdDetail' />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  PPFanIdDetail: state.data.PPFanIdDetail,
  AProUnderWaterList: state.data.AProUnderWaterList,
  PPFanIdList: state.data.PPFanIdList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getBaseData: () => {
    Actions_Wind.getAProUnderWaterList(dispatch);
    Actions_Wind.getPPFanIdList(dispatch);
  },
  getPPFanIdDetail: id => Actions_Wind.getPPFanIdDetail(dispatch, { id }),
  postAddNewPPFan: body => Actions_Wind.postAddNewPPFan(dispatch, { body }),
  putPPFanIdDetail: (id, body) => Actions_Wind.putPPFanIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FanDetail);
